React = require 'react'
t = require('views/internal/recup-with-helpers')('boards_page_add_org_button')

module.exports = class extends React.Component
  displayName: 'MemberBoardsAddOrgComponent'
  render: t.renderable ->
    { onClick } = @props
    t.div '.boards-page-board-section.u-clearfix', ->
      t.b onClick, '.quiet-button.u-float-left', ->
        t.format 'create-a-new-organization-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-add-org-button-component.coffee